import './FaqSection.css';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentLocale } from '../../../hooks/useCurrentLocale';
import { FAQ_SCHEMA_BY_LANG } from '../../seo/faqSchemaData';

/**
 * Vidljiva FAQ sekcija na home stranici.
 *
 * SEO razlozi:
 *   - Google trazi da FAQPage JSON-LD (FaqJsonLd.tsx) odgovara VIDLJIVOM
 *     sadrzaju stranice — bez ovoga schema moze biti ignorisana.
 *   - Home je imao samo ~235 reci (ispod preporucenih 250+); FAQ dodaje
 *     300+ reci relevantnog teksta po jeziku.
 *   - Uvodni paragraf ponavlja kljucne reci iz <title> ("online
 *     psihoterapija") i H1 ("put do unutrasnje ravnoteze") u sadrzaju.
 *
 * Pitanja/odgovori dolaze iz FAQ_SCHEMA_BY_LANG — ISTI izvor kao JSON-LD,
 * pa su schema i vidljivi sadrzaj uvek sinhronizovani.
 *
 * Native <details>/<summary> umesto MUI Accordion-a: sav tekst je u DOM-u
 * i pre interakcije (bitno za react-snap prerender i botove).
 */
export const FaqSection: FC = () => {
    const { t } = useTranslation();
    const locale = useCurrentLocale();
    const items = FAQ_SCHEMA_BY_LANG[locale];

    return (
        <section className="faq" aria-labelledby="faq-title">
            <div className="faq__container">
                <h2 id="faq-title" className="faq__title">
                    {t('home.faq.title')}
                </h2>
                <p className="faq__intro">{t('home.faq.intro')}</p>
                <div className="faq__list">
                    {items.map((item, index) => (
                        <details key={index} className="faq__item" open={index === 0}>
                            <summary className="faq__question">{item.question}</summary>
                            <p className="faq__answer">{item.answer}</p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
};
